<!-- Copyright (c) 2021 MOCA Systems, Inc.  All rights reserved. -->

<!--task-edit.component.html-->
<div
	[shakeAnimation]="makeShake"
	class="light-container light-container--border-radius ticket-edit-container"
	[formGroup]="editForm"
>
	<div class="ticket-message-grid">
		<ticket-message [message]="''"></ticket-message>
	</div>
	<!-- CONTENT UNIQUE TO TICKET TYPE -->
	<!-- Single ticket edit -->
	<div class="ticket-edit-container__content multi-edit">
		<!-- Need to show this when the task has been actualized and then toggled back to planned view -->
		<div *ngIf="isPlannedPreview" class="ticket-edit-container__planned-watermark-wrapper">
			<div class="ticket-edit-container__planned-watermark" automationId="plannedWatermark">PLANNED</div>
		</div>
		<div class="ticket-edit-container__header">
			<multi-edit-thumbnail [typeCounts]="data.typeCounts" [currentType]="data.selectedType">
			</multi-edit-thumbnail>
			<div class="multi-edit__masthead">
				<multi-edit-masthead
					[currentType]="data.selectedType"
					[typeCounts]="data.typeCounts"
					[totalTickets]="data.originalList.size"
				>
				</multi-edit-masthead>
			</div>
			<div class="ticket-edit-container__icons">
				<!--<ticket-icons [promiseStack]="data.data.livePromisePeriodStack" [ticketType]="data.selectedType"></ticket-icons>-->
			</div>
			<div class="ticket-edit-container__hamburger-menu">
				<ticket-action-menu [editTicketCombined]="data"></ticket-action-menu>
				<!-- Commenting out as part of TP-2033, this appears to be legacy code and there's no way to trigger variance reason in multi edit task -->
				<!-- <variance-prompt [formControl]="varianceControl" *ngIf="editForm.contains('variance')" class="variance-prompt--edit-shifted"
						[variance$]="planState.variances.list$"
						[shake$]="planState.shakeVariancePrompt$"
						(done)="variancePromptSaved($event)"
						(canceled)="variancePromptCanceled()"
						[showCancelButton]=false
						saveButtonText="Close"
				></variance-prompt> -->
			</div>
		</div>

		<multi-wrapper
			(onClear)="clearInput('roleId')"
			[metadataValue]="data.keyMetadata.get('roleId')"
			[disableClear]="true"
			[multipleValuesLabel]="appStrings.GENERAL_MULTIPLE_ROLES"
			class="grid-ticket-subcomponent-wrapper ticket-edit-container__role multi-edit--location dropdown-set-width"
		>
			<ticket-role
				class="grid-ticket-subcomponent-wrapper__input"
				formControlName="roleId"
				automationId="roleId"
				[roleList]="planState.rolesApi.data.list$"
				[allowNullSelection]="false"
				[projectMember]="projectMember$ | async"
			>
			</ticket-role>
		</multi-wrapper>

		<multi-wrapper
			(onClear)="clearInput('locationId')"
			[metadataValue]="data.keyMetadata.get('locationId')"
			[disableClear]="true"
			[multipleValuesLabel]="appStrings.GENERAL_MULTIPLE_LOCATIONS"
			class="grid-ticket-subcomponent-wrapper ticket-edit-container__location multi-edit--location dropdown-set-width"
		>
			<ticket-location
				class="grid-ticket-subcomponent-wrapper__input"
				formControlName="locationId"
				automationId="locationId"
				[locationList]="planState.locationsApi.data.list$"
			>
			</ticket-location>
		</multi-wrapper>

		<multi-wrapper
			(onClear)="clearInput('activityName')"
			[metadataValue]="data.keyMetadata.get('activityName')"
			[disableClear]="true"
			class="multi-edit--description grid-ticket-subcomponent-wrapper"
			[multipleValuesLabel]="appStrings.GENERAL_MULTIPLE_DESCRIPTIONS"
		>
			<ticket-description
				class="grid-ticket-subcomponent-wrapper__input ticket-description-fixed-height--multi-edit-constraint"
				[shouldFocus]="data.ticketJustAdded"
				formControlName="activityName"
			></ticket-description>
		</multi-wrapper>
		<multi-wrapper
			(onClear)="clearInput('liveCrewSize')"
			[metadataValue]="data.keyMetadata.get('liveCrewSize')"
			[disableClear]="true"
			class="multi-edit--crew grid-ticket-subcomponent-wrapper"
			[multipleValuesLabel]="appStrings.GENERAL_MULTIPLE_CREW"
		>
			<ticket-crew
				class="grid-ticket-subcomponent-wrapper__input"
				formControlName="liveCrewSize"
			></ticket-crew>
		</multi-wrapper>

		<multi-wrapper
			(onClear)="clearInput('liveDurationDays')"
			[metadataValue]="data.keyMetadata.get('liveDurationDays')"
			[disableClear]="true"
			class="multi-edit--days grid-ticket-subcomponent-wrapper"
			[multipleValuesLabel]="appStrings.GENERAL_MULTIPLE_DAYS"
		>
			<ticket-duration
				class="grid-ticket-subcomponent-wrapper__input"
				formControlName="liveDurationDays"
			></ticket-duration>
		</multi-wrapper>

		<multi-wrapper
			*ngIf="isAdmin$ | async"
			(onClear)="clearInput('externalScheduleId')"
			[metadataValue]="data.keyMetadata.get('externalScheduleId')"
			class="multi-edit--esid grid-ticket-subcomponent-wrapper"
			[multipleValuesLabel]="appStrings.TICKET_EDIT_MULTIPLE_EXTERNAL_SCHEDULE_ID"
		>
			<ticket-ext-sched-id
				class="grid-ticket-subcomponent-wrapper__input"
				formControlName="externalScheduleId"
			>
			</ticket-ext-sched-id>
		</multi-wrapper>

		<multi-wrapper
			*ngIf="(isAdmin$ | async) && (isWbsCodeEnabled$ | async)"
			(onClear)="clearInput('wbsCode')"
			[metadataValue]="data.keyMetadata.get('wbsCode')"
			class="multi-edit--wbs-code grid-ticket-subcomponent-wrapper"
			[multipleValuesLabel]="appStrings.TICKET_EDIT_MULTIPLE_WBS_CODE_LABEL"
		>
			<ticket-wbs-code
				class="grid-ticket-subcomponent-wrapper__input"
				formControlName="wbsCode"
			></ticket-wbs-code>
		</multi-wrapper>
	</div>

	<ticket-footer
		[showMoreDetailsButton]="false"
		[showActualizedToggle]="false"
		[actualPhase]="data.data.actualPhase"
		[isReadOnly]="(planAccess$ | async) === PlanAccessLevel.archived"
		[formDirty]="editForm.dirty"
		[formValid]="isFormValid"
		[isPlanRegion]="data.ticketsInPlanRegion"
		(onActualChange)="updateActualPhase($event)"
		(canceled)="ticketEditService.closeEdit()"
		(saved)="save()"
	>
	</ticket-footer>
</div>
